import React, { useState } from 'react';
import Loader from 'components/Loader';
import './ChatInput.scss';

interface ChatInputProps {  
  disabled: boolean;
  // eslint-disable-next-line no-unused-vars
  onSubmit: (value: string) => void;
}

function ChatInput({ disabled, onSubmit }: ChatInputProps) {
  const [value, setValue] = useState('');

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };
  
  const handleSubmit = () => {
    if (value.trim() === '') return; // Prevent submitting empty messages
    onSubmit(value);
    setValue('');
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && !disabled && value.trim() !== '') {
      handleSubmit();
    }
  };

  const isSendDisabled = disabled || value.trim() === '';

  return (
    <div className="chat-input">
      { disabled && <Loader />}
      <input
        type="text"
        value={value}
        onChange={onChange}
        onKeyDown={handleKeyDown}
        placeholder="Enter your message"
        disabled={disabled}
        style={{ paddingLeft: disabled ? 40 : 15 }}
      />
      <button onClick={handleSubmit} disabled={isSendDisabled}>
        Send
      </button>
    </div>
  );
}

export default ChatInput;
